import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from 'auth';
import {
  DataContext,
  DataContextService,
  FeaturesLakeFrontV2Service,
  LakeFrontV2Module,
  ReportFilterManager,
  ReportFilterService,
  ValueExpression,
} from 'lake-front-v2';
import { Observable, of } from 'rxjs';

import { PageHeaderComponent } from '@terminus-ui/page-header';

@Component({
  selector: 'ds-unified-company-data',
  template: `
    <tux-page-header
      pageTitle="Unified Account Data"
      description=""
      [subMenu]="false"
      [hasCohortDate]="true"
    >
    </tux-page-header>
    <div class="m-5 flex flex-column gap-2">
      <h2 class="text-2xl flex">Unified Company Data</h2>
      <lf-global-vertical-filter-rail
        [filterManager]="filterManager"
      ></lf-global-vertical-filter-rail>
      <lf-protocols-prime-table
        class="flex w-full"
        reportName="all_data"
        protocolName="main"
        [dataContext]="dataContext$ | async"
        [reportFilterManager]="filterManager"
        [columnPickerEnabled]="true"
        [searchFilter]="tableFilter"
      ></lf-protocols-prime-table>
    </div>
  `,
  styles: `
    ::ng-deep lf-protocols-prime-table p-table {
      width: 100%;
    }
  `,
  host: {
    class: 'w-full',
  },
  imports: [LakeFrontV2Module, CommonModule, PageHeaderComponent],
})
export class UnifiedCompanyDataComponent {
  authService = inject(AuthService);
  dcs = inject(DataContextService);
  reportFilterManager = inject(ReportFilterService);

  userInputForReport$ = this.dcs.combinedWithBaseUserInput({});

  tableFilter: (filterValue: string | null) => ValueExpression | null;
  dataContext$: Observable<DataContext>;
  filterManager: ReportFilterManager;

  lakeFrontV2 = inject(FeaturesLakeFrontV2Service);

  constructor() {
    this.dataContext$ = this.dcs.newDataContext(
      'accounts_unified_data.v1',
      of({}),
      this.userInputForReport$,
      this.authService.myTerminusToken$,
    );

    this.filterManager = this.reportFilterManager.newFilterManager({
      dataContext: this.dataContext$,
      reportName: 'all_data',
      unsubscribeFunction: takeUntilDestroyed(),
    });

    this.tableFilter = (filterValue: string | null): ValueExpression | null => {
      if (filterValue === null || filterValue === '') return null;
      return {
        function: {
          function: 'CONTAINS',
          parameters: [
            { literal: { alphaNumeric: filterValue } },
            { rowValue: { metadataId: 'crm_account_name' } },
          ],
        },
      };
    };
  }
}
